import Rule from "../../../common/rule";
import FootballState from "../../../football/state/football-state";

export default class StatsCountRule extends Rule {
    applicable(gameContext, ruleContext, eventConfiguration, { play }) {
        return !play.historyContains(FootballState.NoPlay);
    }

    // eslint-disable-next-line no-unused-vars
    async apply(gameContext, ruleContext, eventConfiguration) {}
}
